import React, { useState } from 'react';
import { Heart, Send, ShieldCheck, Loader2 } from 'lucide-react';
import './LandingPage.css';

const BACKEND_API_URL =
  process.env.REACT_APP_BACKEND_API_URL || "http://localhost:5000";

function LandingPage() {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCreateLink = async () => {
    if (!name.trim()) {
      alert("Please enter a name!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${BACKEND_API_URL}/api/create-card`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ recipientName: name }),
      });

      const data = await res.json();

      if (data.success) {
        window.location.href = `/success?cardId=${data.cardId}`;
      } else {
        alert("Something went wrong. Please try again.");
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      alert("Server error. Try again later.");
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      <div className="landing-header">
        <div className="heart-wrapper">
          <Heart className="heart-icon" fill="#e11d48" />
        </div>

        <h1 className="landing-title">
          Ask Your <span className="title-accent">Valentine</span>
        </h1>

        <p className="landing-subtitle">
          Create a magical link they'll never forget.
        </p>
      </div>

      <div className="landing-card">
        <div className="demo-section">
          <p className="demo-label">See it in action ✨</p>
          <img
            src="/demo.gif"
            alt="Valentine Card Demo"
            className="landing-demo-gif"
          />
        </div>

        <div className="card-body">
          <label className="label">Who is the lucky person?</label>

          <input
            type="text"
            placeholder="Enter their name..."
            className="landing-input"
            value={name}
            maxLength={30}
            onChange={(e) => setName(e.target.value)}
          />

          <button
            className="landing-button"
            onClick={handleCreateLink}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="button-icon animate-spin" />
                <span>Creating...</span>
              </>
            ) : (
              <>
                <Send className="button-icon" size={18} />
                <span>Create Free Link</span>
              </>
            )}
          </button>

          <div className="trust-badges">
            <div className="trust-item">
              <ShieldCheck size={14} />
              100% Free
            </div>
            <div className="trust-dot"></div>
            <div className="trust-text">No Login Required</div>
          </div>
        </div>

        <div className="card-footer">
          <p>✨ Your link is generated instantly.</p>
        </div>
      </div>

      <footer className="landing-footer">
        Made with ❤️ for modern romantics.
      </footer>
    </div>
  );
}

export default LandingPage;
